import {RouteRecordRaw} from 'vue-router'
import Search from "@/views/Search.vue";
import ProgettiDismessi from "@/views/ProgettiDismessi.vue";
import HomeProgetti from "@/views/HomeProgetti.vue";
import MainMenu from "@/components/MainMenu.vue";
import DettaglioSottoProgetto from "@/views/DettaglioSottoProgetto.vue";
import ListaSottoProgetti from "@/views/ListaSottoProgetti.vue";
import VersioniSottoProgetto from "@/views/VersioniSottoProgetto.vue";
import DettaglioVersioneSottoProgetto from "@/views/DettaglioVersioneSottoProgetto.vue";
import ListaBudget from "@/views/ListaBudget.vue";
import ListaOrdini from "@/views/ListaOrdini.vue";
import SottoProgettoListaFornitori from "@/views/SottoProgettoListaFornitori.vue";
import SottoProgettoDettaglioFornitore from "@/views/SottoProgettoDettaglioFornitore.vue";
import DettaglioProgettoMenu from "@/components/DettaglioProgettoMenu.vue";
import DettaglioProgetto from "@/views/DettaglioProgetto.vue";
import SottoProgettiMenu from "@/components/SottoProgettiMenu.vue";
import SottoProgettoPianoFatturazione from "@/views/SottoProgettoPianoFatturazione.vue";
import SottoProgettoODV from "@/views/SottoProgettoODV.vue";
import ListaPianoDiFatturazione from "@/views/ListaPianoDiFatturazione.vue";
import CostiRicaviSottoProgetto from "@/views/Sottoprogetto/CostiRicaviSottoProgetto.vue";
import CostiRicaviCarteSottoProgetto from "@/views/Sottoprogetto/CostiRicaviCarteSottoProgetto.vue";
import CostiRicaviBiglietteriaFerroviariaSottoProgetto
    from "@/views/Sottoprogetto/CostiRicaviBiglietteriaFerroviariaSottoProgetto.vue";
import CostiRicaviBiglietteriaAereaSottoProgetto
    from "@/views/Sottoprogetto/CostiRicaviBiglietteriaAereaSottoProgetto.vue";
import CostiRicaviPreventivoSottoProgetto from "@/views/Sottoprogetto/CostiRicaviPreventivoSottoProgetto.vue";
import CostiNoteSpesaSottoProgetto from "@/views/Sottoprogetto/CostiNoteSpesaSottoProgetto.vue";
import CostiTimesheetSottoprogetto from "@/views/Sottoprogetto/CostiTimesheetSottoprogetto.vue";
import CostiFinanziariSottoprogetto from "@/views/Sottoprogetto/CostiFinanziariSottoprogetto.vue";
import CostiContrattiSottoprogetto from "@/views/Sottoprogetto/CostiContrattiSottoprogetto.vue";
import RicaviSottoprogetto from "@/views/Sottoprogetto/RicaviSottoprogetto.vue";
import DettaglioOda from "@/views/Ordini/DettaglioOda.vue";
import DettaglioOdv from "@/views/Ordini/DettaglioOdv.vue";
import IncassiPagamentiSottoProgetto from "@/views/Sottoprogetto/IncassiPagamentiSottoProgetto.vue";
import FattureClientiSottoProgetto from "@/views/Sottoprogetto/FattureClientiSottoProgetto.vue";
import FattureFornitoreSottoProgetto from "@/views/Sottoprogetto/FattureFornitoreSottoProgetto.vue";
import DocumentiFornitoriSottoprogetto from "@/views/Sottoprogetto/DocumentiFornitoriSottoprogetto.vue";

const projectRoutes: Array<RouteRecordRaw> = [
    {
        path: '/projects/',
        meta: {'app': 'prj'},
        components: {
            default: HomeProgetti,
            nav: MainMenu,
        },
        props: true,
        children: [
            {
                path: '',
                component: ProgettiDismessi,
                name: 'ListaProgetti',
                props: false
            },
            {
                path: 'sottoprogetti/lista/',
                component: ListaSottoProgetti,
                name: 'ListaSottoProgetti'
            },
            {
                path: 'pianodifatturazione/',
                component: ListaPianoDiFatturazione,
                name: 'ListaPianoDiFatturazione'
            },
            {
                path: 'budget/',
                component: ListaBudget,
                name: 'ListaBudget'
            },
            {
                path: 'posts',
                component: Search,
            },
            {
                path: 'ordini/',
                component: ListaOrdini,
                name: 'ListaOrdini',
                props: true
            },
        ],
    },
    {
        path: '/project/',
        meta: {'app': 'prj'},
        components: {
            default: HomeProgetti,
            nav: DettaglioProgettoMenu,
        },
        props: true,
        children: [
            {
                path: ':id/',
                component: DettaglioProgetto,
                name: 'DettaglioProgetto',
                props: true,
            },
        ],
    },

    {
        path: '/subprojects/',
        meta: {'app': 'spj'},
        components: {
            default: HomeProgetti,
            nav: SottoProgettiMenu,
        },
        props: true,
        children: [
            {
                path: ':id/',
                component: DettaglioSottoProgetto,
                name: 'DettaglioSottoProgetto',
                props: true,
            },
            {
                path: ':id/fornitori/',
                component: SottoProgettoListaFornitori,
                name: 'SottoProgettoListaFornitori',
                props: true,
            },
            {
                path: ':id/odv/',
                component: SottoProgettoODV,
                name: 'SottoProgettoODV',
                props: true,
            },
            {
                path: ':id/piano_fattuazione/',
                component: SottoProgettoPianoFatturazione,
                name: 'SottoProgettoPianoFatturazione',
                props: true,
            },
            {
                path: ':id/fornitori/:idf/',
                component: SottoProgettoDettaglioFornitore,
                name: 'SottoProgettoDettaglioFornitore',
                props: true,
            },
            {
                path: ':id/versioni/',
                component: VersioniSottoProgetto,
                name: 'VersioniSottoProgetto',
                props: true,
            },
            {
                path: ':id/costi_ricavi/',
                component: CostiRicaviSottoProgetto,
                name: 'SottoprogettoCostiRicavi',
                props: true,
            },
            {
                path: ':id/documenti_fornitori/',
                component: DocumentiFornitoriSottoprogetto,
                name: 'SottoprogettoDocumentiFornitori',
                props: true,
            },
            {
                path: ':id/costi_ricavi/costi_carte',
                component: CostiRicaviCarteSottoProgetto,
                name: 'CostiCarte',
                props: true,
            },
            {
                path: ':id/costi_ricavi/incassi_pagamenti',
                component: IncassiPagamentiSottoProgetto,
                name: 'IncassiPagamenti',
                props: true,
            },
            {
                path: ':id/costi_ricavi/fatture_clienti',
                component: FattureClientiSottoProgetto,
                name: 'FattureCliente',
                props: true,
            },
            {
                path: ':id/costi_ricavi/fatture_fornitore',
                component: FattureFornitoreSottoProgetto,
                name: 'FattureFornitore',
                props: true,
            },
            {
                path: ':id/costi_ricavi/costi_preventivo',
                component: CostiRicaviPreventivoSottoProgetto,
                name: 'CostiPreventivo',
                props: true,
            },
            {
                path: ':id/oda/:ditta/:n_reg/',
                component: DettaglioOda,
                name: 'DettaglioOda',
                props: true,
            },
            {
                path: ':id/odv/:ditta/:n_reg/',
                component: DettaglioOdv,
                name: 'DettaglioOdv',
                props: true,
            },
            {
                path: ':id/costi_ricavi/costi_biglietteria_ferroviaria',
                component: CostiRicaviBiglietteriaFerroviariaSottoProgetto,
                name: 'CostiBiglietteriaFerroviaria',
                props: true,
            },
            {
                path: ':id/costi_ricavi/costi_biglietteria_aerea',
                component: CostiRicaviBiglietteriaAereaSottoProgetto,
                name: 'CostiBiglietteriaAerea',
                props: true,
            },
            {
                path: ':id/costi_ricavi/costi_note_spesa',
                component: CostiNoteSpesaSottoProgetto,
                name: 'CostiNoteSpesa',
                props: true,
            },
            {
                path: ':id/costi_ricavi/costi_timesheet',
                component: CostiTimesheetSottoprogetto,
                name: 'CostiTimesheet',
                props: true,
            },
            {
                path: ':id/costi_ricavi/costi_finanziari',
                component: CostiFinanziariSottoprogetto,
                name: 'CostiFinanziari',
                props: true,
            },
            {
                path: ':id/costi_ricavi/costi_contratti',
                component: CostiContrattiSottoprogetto,
                name: 'CostiContratti',
                props: true,
            },
            {
                path: ':id/costi_ricavi/ricavi',
                component: RicaviSottoprogetto,
                name: 'RicaviPreventivo',
                props: true,
            },
            {
                path: ':id/versioni/:idv/',
                component: DettaglioVersioneSottoProgetto,
                name: 'DettaglioVersioneSottoProgetto',
                props: true
            },
        ],
    },
]

export default projectRoutes
